import { NativeApp, NativeAppType, ScanBarcodeResult } from "./";

// Tell Typescript about the webkit property iOS puts on window
declare global {
  interface Window {
    webkit?: Webkit;
  }
}

const nativeApp = window.webkit?.messageHandlers;

/** Defines the methods that are available on the IOS Native App */
export interface Webkit {
  messageHandlers: {
    scanBarcode: WebkitMessageHandler<{}>;
    navigateToEditServer: WebkitMessageHandler<{}>;
  };
}

export interface WebkitMessageHandler<T> {
  postMessage(params: T): void;
}

/** Defines the methods that are available for the iOS Native App to call */
// eslint-disable-next-line @typescript-eslint/interface-name-prefix
export interface IOSActions {
  sendBarcodeResult(result: ScanBarcodeResult): void;
}

export function isIOS() {
  return !!nativeApp;
}

// This represents the communication from Vue to the iOS app
export default class IOS implements NativeApp, IOSActions {
  readonly type = NativeAppType.iOS;
  readonly isMobile = true;

  private scanBarcodeCallback?: (result: ScanBarcodeResult) => void;

  register() {
    // Create a property on window that the iOS app can use to communicate with Vue.js
    (window as any).iOS = this;
  }

  // ----------------- Vue.js to iOS -----------------
  scanBarcode(): Promise<string | undefined> {
    return new Promise<string | undefined>((resolve, reject) => {
      // If there is a pending callback (not likely), cancel it since a new scan request has started
      this.scanBarcodeCallback?.({});

      // Register the callback before telling the native app to scan a barcode
      this.scanBarcodeCallback = result => {
        // Clear the callback after getting the result
        this.scanBarcodeCallback = undefined;

        resolve(result.barcode);
      };

      nativeApp?.scanBarcode.postMessage({});
    });
  }

  navigateToEditServer(): void {
    nativeApp?.navigateToEditServer.postMessage({});
  }

  // ----------------- iOS to Vue.js -----------------
  sendBarcodeResult(result: ScanBarcodeResult): void {
    this.scanBarcodeCallback?.(result);
  }
}
